import React, { createContext, useContext, useState } from 'react';

interface CalendarHoverContextValue {
  hoveredVacationKey: string | null;
  setHoveredVacationKey: (key: string | null) => void;
}

const CalendarHoverContext = createContext<CalendarHoverContextValue>({
  hoveredVacationKey: null,
  setHoveredVacationKey: () => undefined,
});

export const CalendarHoverProvider = ({ children }: { children: React.ReactNode }) => {
  const [hoveredVacationKey, setHoveredVacationKey] = useState<string | null>(null);
  return (
    <CalendarHoverContext.Provider value={{ hoveredVacationKey, setHoveredVacationKey }}>
      {children}
    </CalendarHoverContext.Provider>
  );
};

export const useCalendarHover = () => useContext(CalendarHoverContext);
